<template>
  <div>
    <transition name="fade">
      <div v-show="show" class="cm-contacts-m-container" >
        <div class="cm-contacts-m-form">
          <Contacts 
            v-model="options" 
            @close="$emit('close')" 
            :org-id="orgId"
          />
        </div>
      </div>
    </transition>
  </div>
</template>

<script>

import Contacts from './components/Contacts.vue'

export default {
  components: { Contacts },

  props: {
    show: {
      type: Boolean, 
      default: false
    },
    value: {
      type: Array,
      required: true
    },
    orgId: {
      type: String,
      required: false,
      default: null
    }
  },

  data () {
    return {
      options: []
    }
  },

  watch: {
    value (val) {
      this.options = val
    },

    options (newSet) {
      this.$emit('input', newSet, this.$store.state.contactContext)
    }
  },

  mounted () {
    this.options = this.value
  },
}
</script>

<style lang="scss" scoped>
// full page container
.cm-contacts-m-container {
  position: absolute;
  height: 100%; width: 100%;
  left: 0; top: 0;
  background: rgba(0,0,0,0.5);
  display: flex;
  justify-content: space-around;
  align-items: center;
  z-index: 9999;

  // form container
  .cm-contacts-m-form {
    background: transparent;
    width: 900px;
    height: 100%;
    display: flex;
    justify-content: space-around;
    align-items: center;
  }
}
</style>